import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StoreNodesConstructor, { StoreNodes } from "csi/store/Nodes";
import ColumnAssociation from "csi/table/matrix/ColumnAssociation";
import { PATH_OP_PARENT, getUrlPath, pathCreate } from "csi/utility/pathUtility";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";

const SupplierComparisonMatrix = declare(ColumnAssociation, {
	bAllowColumnFilter: true,
	columnAssociation: "Supplier",
	columnAssociationPath: "Child:__Parent__",

	/** @property {C8Node[]} suppliers - suppliers used in hierarchy */
	suppliers: null,

	/**
	 * @override
	 * Create new store each time view is rendered and make request for all Suppliers used in hierarchy
	 */
	addDeferred(ctx: Context, h: Heading, dfds: PromiseLike<any>[]): void {
		const store = this._getConfigurableStore(ctx);

		dfds.push(store.asyncQuery().then((results) => {
			this.suppliers = results;
		}));
	},

	/**
	 * @override
	 * Return store containing column nodes
	 */
	getColumnQueryLevelStore(ctx: Context, h: Heading): StoreNodes {
		return this._getConfigurableStore(ctx);
	},

	/**
	 * @override
	 * Return supplier nodes
	 */
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] {
		return this.suppliers;
	},

	/**
	 * Create data store that queries for referenced Suppliers in the hierarchy
	 */
	_getConfigurableStore(ctx: Context): StoreNodes {
		const relationMap = {
			MaterialSecurityGroup: "MaterialSecurityGroups",
			Season: "ParentSeason",
		};

		const type = ctx.defView.getRootClass().type;
		const relation = relationMap[type] || type;
		const path = pathCreate(PATH_OP_PARENT, relation, "ProductSourcing", "ProductSources", "Supplier");
		const configurableStore = new StoreNodesConstructor({
			cachingStore: ctx.cache,
			sortQuery: new Query().SortByNode(xml.PROP_NAME),
			typeNode: "Supplier",
			requestParameters: {
				"Qry.Limit.Path": getUrlPath(ctx.view.urlRoot, path),
			},
		});

		ctx.view.annotateViewStore(configurableStore);

		return configurableStore;
	},
});

export = SupplierComparisonMatrix;
